module.exports = {
      id: "analysis-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#analysis",
      toString: function () {
        return this.url;
      }
    }